import { GzCarouselInfoCardWebComponent } from './component/GzCarouselInfoCardWebComponent';

export { GzCarouselInfoCardWebComponent };
